import { createNativeStackNavigator } from "@react-navigation/native-stack";

import DeliveryFulfillmentsHeader from "./DeliveryFulfillmentsHeader";
import {
  DeliveryFulfillmentsStackParamList,
  deliveryFulfillmentsRoutes,
} from "./types";
import {
  DeliveryFulfillmentsProvider,
  TDeliveryOptions,
} from "../contexts/DeliveryFulfillmentsContext";
import AutomaticFulfillmentScreen from "../screens/AutomaticFulfillment";
import AutomaticFulfillmentsScreen from "../screens/AutomaticFulfillmentsScreen";
import DeliveryModeListScreen from "../screens/DeliveryModeListScreen";
import MapScreen from "../screens/MapScreen";
import PickupLocationScreen from "../screens/PickupLocationScreen";

const Stack = createNativeStackNavigator<DeliveryFulfillmentsStackParamList>();

export default function DeliveryFulfillmentsNavigator(props: TDeliveryOptions) {
  const {
    deliveryModeList,
    automaticFulfillments,
    automaticFulfillment,
    pickupLocation,
    map,
  } = deliveryFulfillmentsRoutes;

  return (
    <DeliveryFulfillmentsProvider {...props}>
      <Stack.Navigator
        initialRouteName={deliveryModeList}
        screenOptions={{
          header: (props) => <DeliveryFulfillmentsHeader {...props} />,
        }}
      >
        <Stack.Screen
          name={deliveryModeList}
          component={DeliveryModeListScreen}
        />
        <Stack.Screen
          name={automaticFulfillments}
          component={AutomaticFulfillmentsScreen}
        />

        <Stack.Screen
          name={automaticFulfillment}
          component={AutomaticFulfillmentScreen}
          options={({ route }) => ({
            headerTitle:
              route.params.type === "on_demand"
                ? "Envío directo"
                : route.params.type === "scheduled"
                ? "Envío diferido"
                : "Envío",
          })}
        />
        <Stack.Screen name={pickupLocation} component={PickupLocationScreen} />
        <Stack.Screen name={map} component={MapScreen} />
      </Stack.Navigator>
    </DeliveryFulfillmentsProvider>
  );
}
